import { actionCreatorFactory } from 'typescript-fsa';
import { IApiErrorParams } from '@cbridge-packages/api-base';
import { ICoverageServer, ICoverageServerForm } from './coverageServer.interface';

export namespace CoverageServerAction {
  const actionCreator = actionCreatorFactory('CoverageServer');

  interface ICreateParams {
    payload: ICoverageServerForm;
    resolve: (serverId?: ICoverageServer['serverId']) => void;
  }

  interface IUpdateParams {
    payload: ICoverageServerForm;
    resolve: (serverId?: ICoverageServer['serverId']) => void;
  }

  interface IServerId {
    serverId: ICoverageServer['serverId'];
  }

  export const create = actionCreator.async<ICreateParams, IServerId, IApiErrorParams>('CREATE');
  export const update = actionCreator.async<IUpdateParams, void, IApiErrorParams>('UPDATE');
  export const remove = actionCreator.async<IServerId, void, IApiErrorParams>('REMOVE');

  export const loadList = actionCreator.async<void, ICoverageServer[], IApiErrorParams>('LOAD_LIST');

  export const destroy = actionCreator('DESTROY');
}
